import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./SubcontractorList.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'
import { ButtonStandard, SubcontractorFilter } from "../../components";
import formatCnpj from '../../helpers/formatCnpj';

function SubcontractorList(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);
    const filters = useSelector(state => state.subcontractor.filter);

	const subcontractorList     = useSelector(state => state.subcontractor.subcontractorList);
    const isLoadingList         = useSelector(state => state.subcontractor.isLoading);
    const page                  = useSelector(state => state.subcontractor.listPage);
    const hasMore               = useSelector(state => state.subcontractor.listHasMore);
    const selectedSubcontractor = useSelector(state => state.subcontractor.selectedSubcontractor);
        
    const [isTableEmpty, setIsTableEmpty] = useState(false)

	const pageMessages = messages[lang].subcontractorListPage;
	const titleTable   = messages[lang].subcontractorListPage.tableTitle;
    const titlePage    = messages[lang].subcontractorListPage.inquiry;

	const header = [
		pageMessages.cnpj,
		pageMessages.nomeFantasia,
		pageMessages.razaoSocial,
        pageMessages.dataCriacao,
        pageMessages.status,
        pageMessages.email,
        ""
	];

    useEffect(() => {
		dispatch({
			type: 'GET_SUBCONTRACTORS',
            page: 0,
            filter: filters,
            cleanTable: true
		})
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
		if (selectedSubcontractor.id) {
			history.push('/subcontractor-details')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedSubcontractor]);

    useEffect(() => {
		if (subcontractorList.length > 0) {
			setIsTableEmpty(false)
		} else {
            setIsTableEmpty(true)
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [subcontractorList]);

    const handleHasMore = () => {
		dispatch({
			type: 'GET_SUBCONTRACTORS',
			page: page,
			filter: filters
		})
	}

	const mappedSubcontractorList = () => {
		return subcontractorList.map((item) => {
			return [
                    { 
                        text:  item.cnpj ? formatCnpj(item.cnpj) : '',
                    },
                    { 
                        text: item.nomeFantasia,
                        maxLength: 4000
                    },
                    { 
                        text: item.razaoSocial,
                        maxLength: 4000
                    },
                    item.dataCadastro
                        ?                  
                        {
                            text: item.dataCadastro,
                            type: 'datehour',
                        }
                        :
                        '--/--/----',
                    item.status
                        ?                  
                        {
                            text: item.status.descricao,
                        }
                        :
                        '',
                    { 
                        text: item.email,
                    },
                    {
						text: <i className="icon-pen" />,
                        onClick: () => {
							dispatch({
								type: 'SET_SELECTED_SUBCONTRACTOR',
								payload: {
                                    id: item.id,
                                    data: item
                                }
							})
						},
					}
				]

		});
	}

    const getSubcontractors = () => {
        dispatch({
			type: 'GET_SUBCONTRACTORS',
            page: 0,
            filter: filters,
            cleanTable: true
		})
	}

	return (
		<div className="subcontractor-list-page">          
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
                <SubcontractorFilter />
            </Container>

            <Container className="px-4 d-flex justify-content-end">
                <ButtonStandard
					text={pageMessages.newSubcontractor}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => history.push('/subcontractor-details')}/>

				<ButtonStandard
					text={pageMessages.search}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getSubcontractors()}/>
			</Container>

            <Container className="pt-3 justify-content-start">
                <Container className="mt-1 pt-1 mb-4 pb-5">
                    <ItemList
                        header={header}
                        titleTable={titleTable}
                        listTable={mappedSubcontractorList()}
                        isLoading={isLoadingList && subcontractorList.length === 0 ? true : false}
                        isEmpty={isTableEmpty}
                        hasMore={hasMore}
                        handleHasMore={handleHasMore}
                        hasMoreIsLoading={isLoadingList}
                        />
                </Container>
            </Container>            
		</div>
	)
}

export default withRouter(SubcontractorList);